"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var projectsList_1 = require("common/global/projectsList");
var warehousesList_1 = require("common/global/warehousesList");
var app_1 = require("firebase/app");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var useTitle_1 = __importDefault(require("../../hooks/useTitle"));
var react_router_dom_1 = require("react-router-dom");
function NewsView() {
    var uid = (0, app_1.auth)().currentUser.uid;
    var _a = (0, react_1.useState)(undefined), notificationSnapshot = _a[0], setNotificationSnapshot = _a[1];
    var _b = (0, firestore_1.useCollection)(collectionsRef_1.notificationsRef.where("userId", "==", uid).where("read", "==", false)), NotificationSN = _b[0], loadingNotifications = _b[1];
    var userSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.usersRef)[0];
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t("common.notifications"));
    var fifteenDayBefore = (0, moment_1.default)()
        .subtract(15, "day")
        .toDate();
    (0, react_1.useEffect)(function () {
        collectionsRef_1.notificationsRef
            .where("userId", "==", uid)
            .where("createdAt", ">=", fifteenDayBefore)
            .orderBy("createdAt", "desc")
            .onSnapshot(function (x) {
            setNotificationSnapshot(x);
        });
    }, [fifteenDayBefore, uid]);
    if (!notificationSnapshot || !userSnapshot || loadingNotifications) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
            backgroundColor: "#f0f2f5",
        } }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginRight: 20,
                } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ danger: true, onClick: function () {
                        NotificationSN === null || NotificationSN === void 0 ? void 0 : NotificationSN.docs.map(function (doc) {
                            collectionsRef_1.notificationsRef.doc(doc.id).update({
                                read: true,
                            });
                        });
                        console.log(NotificationSN === null || NotificationSN === void 0 ? void 0 : NotificationSN.docs.length);
                    } }, { children: "Read All" })) })), notificationSnapshot === null || notificationSnapshot === void 0 ? void 0 : notificationSnapshot.docs.map(function (item) {
                var _a, _b, _c, _d, _e;
                var orderNotificationData = __assign(__assign({}, item.data()), { id: item.id });
                var warehouseNotificationData = __assign(__assign({}, item.data()), { id: item.id });
                var projectCode = (_a = projectsList_1.globalProjectsData[orderNotificationData.projectId]) === null || _a === void 0 ? void 0 : _a.code;
                var warehouse = warehouseNotificationData.warehouseId
                    ? (_b = warehousesList_1.globalWarehousesData[warehouseNotificationData.warehouseId]) === null || _b === void 0 ? void 0 : _b.name
                    : "";
                var fromWarehouse = warehouseNotificationData.fromWarehouseId
                    ? (_c = warehousesList_1.globalWarehousesData[warehouseNotificationData.fromWarehouseId]) === null || _c === void 0 ? void 0 : _c.name
                    : "";
                var toWarehouse = warehouseNotificationData.toWarehouseId
                    ? (_d = warehousesList_1.globalWarehousesData[warehouseNotificationData.toWarehouseId]) === null || _d === void 0 ? void 0 : _d.name
                    : "";
                var ref = (_e = orderNotificationData === null || orderNotificationData === void 0 ? void 0 : orderNotificationData.content) === null || _e === void 0 ? void 0 : _e.ref;
                var msg = function () {
                    var msgContent = "";
                    switch (warehouseNotificationData.type) {
                        case "approve":
                        case "confirm":
                            msgContent = "A ".concat(warehouseNotificationData.operation, " operation of ").concat(warehouseNotificationData.quantity, " of ").concat(warehouseNotificationData.productId, " in ").concat(warehouse, " warehouse from ").concat(projectCode, " project is waiting your ").concat(warehouseNotificationData.type === "approve"
                                ? "approval"
                                : "confirmation");
                            return msgContent;
                        case "cancel":
                            msgContent = "A ".concat(warehouseNotificationData.operation, " operation of ").concat(warehouseNotificationData.quantity, " of ").concat(warehouseNotificationData.productId, " in ").concat(warehouse, " warehouse from ").concat(projectCode, " project has been ").concat(warehouseNotificationData.type, "ed");
                            return msgContent;
                        case "return":
                            msgContent = "".concat(warehouseNotificationData.quantity, " of ").concat(warehouseNotificationData.productId, " in ").concat(warehouse, " warehouse from ").concat(projectCode, " project has been ").concat(warehouseNotificationData.type, "ed from ").concat(fromWarehouse, " to ").concat(toWarehouse);
                            return msgContent;
                    }
                };
                if (["revoked", "cancelled", "approved"].includes(orderNotificationData.action)) {
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: function () {
                            return collectionsRef_1.notificationsRef
                                .doc(orderNotificationData === null || orderNotificationData === void 0 ? void 0 : orderNotificationData.docId)
                                .update({ read: true });
                        }, style: {
                            margin: 12,
                            background: "#fff",
                            borderRadius: 12,
                            padding: 12,
                        } }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/".concat(orderNotificationData.docType, "s/").concat(orderNotificationData === null || orderNotificationData === void 0 ? void 0 : orderNotificationData.id) }, { children: (0, jsx_runtime_1.jsx)(antd_1.Comment, { content: (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginTop: 10, color: "gray" } }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("h4", __assign({ style: orderNotificationData.read
                                                ? { color: "#ccc" }
                                                : null }, { children: "An ".concat(orderNotificationData.docType, " with number ").concat(ref, " project code: ").concat(projectCode, " description: ").concat(orderNotificationData.description, " has been ").concat(orderNotificationData.action) })) }) })), datetime: (0, jsx_runtime_1.jsx)("span", __assign({ style: {
                                        fontSize: "12px",
                                        color: "#ccc",
                                        whiteSpace: "nowrap",
                                    } }, { children: (0, jsx_runtime_1.jsx)("span", { children: (0, moment_1.default)(orderNotificationData === null || orderNotificationData === void 0 ? void 0 : orderNotificationData.createdAt)
                                            .toDate()
                                            .toLocaleString() }) })) }) }), item.id) })));
                }
                else if (warehouseNotificationData.action === "warehouseOperation") {
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: function () {
                            return collectionsRef_1.notificationsRef
                                .doc(warehouseNotificationData === null || warehouseNotificationData === void 0 ? void 0 : warehouseNotificationData.id)
                                .update({ read: true });
                        }, style: {
                            margin: 12,
                            background: "#fff",
                            borderRadius: 12,
                            padding: 12,
                        } }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/warehouses/".concat(warehouseNotificationData === null || warehouseNotificationData === void 0 ? void 0 : warehouseNotificationData.warehouseId, "/").concat(warehouseNotificationData.docType) }, { children: (0, jsx_runtime_1.jsx)(antd_1.Comment, { content: (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginTop: 10, color: "gray" } }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("h4", __assign({ style: warehouseNotificationData.read
                                                ? { color: "#ccc" }
                                                : null }, { children: msg() })) }) })), datetime: (0, jsx_runtime_1.jsx)("span", __assign({ style: {
                                        fontSize: "12px",
                                        color: "#ccc",
                                        whiteSpace: "nowrap",
                                    } }, { children: (0, jsx_runtime_1.jsx)("span", { children: (0, moment_1.default)(warehouseNotificationData === null || warehouseNotificationData === void 0 ? void 0 : warehouseNotificationData.createdAt)
                                            .toDate()
                                            .toLocaleString() }) })) }) }), item.id) })));
                }
            })] })));
}
exports.default = NewsView;
